/**
 * UI-6b Task 9 — ConversationVolume widget manifest.
 */
import { registerWidget } from '../registry.js'
import type { WidgetManifest } from '../types.js'
import {
  ConversationVolumeRenderer,
  type ConversationVolumeConfig,
} from './Renderer.js'
import { ConversationVolumeConfigEditor } from './ConfigEditor.js'

export const conversationVolumeManifest: WidgetManifest<ConversationVolumeConfig> = {
  type: 'conversation-volume',
  label: 'Conversation Volume',
  description: 'Call count over time (line chart).',
  defaultSize: '2x1',
  defaultConfig: { days: 7 },
  Renderer: ConversationVolumeRenderer,
  ConfigEditor: ConversationVolumeConfigEditor,
}

registerWidget(conversationVolumeManifest)
